import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import Kundli_Main_Banner from '../kundli_main_bannner/Kundli_Main_Banner'
import Kundli_Common_Section from '../kundli_common_section/Kundli_Common_Section'
import Kundli_Faq from '../kundli_faq/Kundli_Faq'
import Home_Private_Confidential from '../../home_page_components/home_private_confidential/Home_Private_Confidential'
import Footer from '../../../common/footer/Footer'
import Similar_Daily_Horoscope_Details from './Similar_Daily_Horoscope_Details'
import { Link, useParams } from 'react-router-dom'
import {
    Get_Third_Party_Daily_Horoscope,
    Get_Third_Party_Tomorrow_Horoscope,
    Get_Third_Party_Yesterday_Horoscope,
    Get_Third_Party_Weekly_Horoscope,
    Get_Third_Party_Monthly_Horoscope,
    Get_Third_Party_Yearly_Horoscope,
} from '../../../../api/global/Global'

const HOROSCOPE_TYPE_LABELS = {
    today: 'Daily',
    yesterday: 'Yesterday',
    tomorrow: "Tomorrow's",
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
}

const API_MAP = {
    today: Get_Third_Party_Daily_Horoscope,
    yesterday: Get_Third_Party_Yesterday_Horoscope,
    tomorrow: Get_Third_Party_Tomorrow_Horoscope,
    weekly: Get_Third_Party_Weekly_Horoscope,
    monthly: Get_Third_Party_Monthly_Horoscope,
    yearly: Get_Third_Party_Yearly_Horoscope,
}

const Daily_Horoscope_Details = () => {
    const { horoscopeType = 'today', zodiacSign } = useParams()
    const [prediction, set_Prediction] = useState(null)
    const [expanded, set_Expanded] = useState({})

    const toggle_Expanded = (key) => {
        set_Expanded((prev) => ({ ...prev, [key]: !prev[key] }))
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        const Fetch_Prediction = async () => {
            if (!zodiacSign) return
            try {
                const apiFn = API_MAP[horoscopeType] || Get_Third_Party_Daily_Horoscope
                const response = await apiFn(zodiacSign)
                if (response?.data) {
                    set_Prediction(response.data?.prediction)
                }
            } catch (err) {
                console.error('Horoscope fetch error', err)
            }
        }
        Fetch_Prediction()
    }, [horoscopeType, zodiacSign])

    const zodiacTitle = zodiacSign
        ? zodiacSign.charAt(0).toUpperCase() + zodiacSign.slice(1).toLowerCase()
        : ''
    const horoscopeTypeLabel = HOROSCOPE_TYPE_LABELS[horoscopeType] || 'Daily'

    return (
        <div>
            {/* <---------- header section's --------------> */}
            <Header />
            {/*<---------- Kundli Main Banner ---------------->  */}
            {/* <Kundli_Main_Banner /> */}
            <section className="gi-category py-[40px] max-[767px]:p-[0px] bg-[#F0F4F8]">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5">


                    <div className="kundli_form w-full mt-6">
                        <div className="flex flex-wrap w-full">
                            <div
                                className="min-[992px]:w-[66.33%] flex min-[768px]:w-[50%] min-[576px]:w-[50%] max-[420px]:w-full max-[575px]:w-[50%] max-[575px]:mx-auto md:pr-6 mb-3 mb-md-0">
                                <div className="bg-white p-6">
                                    <div className="w-full">
                                        <h4 className="text-2xl mb-2 font-semibold text-gray-900 capitalize">
                                            {zodiacTitle} {horoscopeTypeLabel} Horoscope
                                        </h4>
                                        <p className="text-gray-700 mb-3">
                                            {prediction?.luck || ''}
                                        </p>
                                    </div>
                                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
                                        <div className="bg-white border border-gray-200 rounded p-5">
                                            <h4 className="text-lg mb-2 font-semibold text-gray-900">Health and well being</h4>
                                            <p className={`text-gray-700 mb-3 ${expanded['health'] ? '' : 'line-clamp-6'}`}>
                                                {prediction?.health || ''}
                                            </p>
                                            <button onClick={() => toggle_Expanded('health')} className="font-semibold text-gray-500">
                                                {expanded['health'] ? 'Read Less..' : 'Read More..'}
                                            </button>
                                        </div>
                                        <div className="bg-white border border-gray-200 rounded p-5">
                                            <h4 className="text-lg mb-2 font-semibold text-gray-900">Love and Relationship</h4>
                                            <p className={`text-gray-700 mb-3 ${expanded['personal_life'] ? '' : 'line-clamp-6'}`}>
                                                {prediction?.personal_life || ''}
                                            </p>
                                            <button onClick={() => toggle_Expanded('personal_life')} className="font-semibold text-gray-500">
                                                {expanded['personal_life'] ? 'Read Less..' : 'Read More..'}
                                            </button>
                                        </div>
                                        <div className="bg-white border border-gray-200 rounded p-5">
                                            <h4 className="text-lg mb-2 font-semibold text-gray-900">Profession</h4>
                                            <p className={`text-gray-700 mb-3 ${expanded['profession'] ? '' : 'line-clamp-6'}`}>
                                                {prediction?.profession || ''}
                                            </p>
                                            <button onClick={() => toggle_Expanded('profession')} className="font-semibold text-gray-500">
                                                {expanded['profession'] ? 'Read Less..' : 'Read More..'}
                                            </button>
                                        </div>
                                        <div className="bg-white border border-gray-200 rounded p-5">
                                            <h4 className="text-lg mb-2 font-semibold text-gray-900">Travel</h4>
                                            <p className={`text-gray-700 mb-3 ${expanded['travel'] ? '' : 'line-clamp-6'}`}>
                                                {prediction?.travel || ''}
                                            </p>
                                            <button onClick={() => toggle_Expanded('travel')} className="font-semibold text-gray-500">
                                                {expanded['travel'] ? 'Read Less..' : 'Read More..'}
                                            </button>
                                        </div>
                                        <div className="bg-white border border-gray-200 rounded p-5">
                                            <h4 className="text-lg mb-2 font-semibold text-gray-900">Emotions</h4>
                                            <p className={`text-gray-700 mb-3 ${expanded['emotions'] ? '' : 'line-clamp-6'}`}>
                                                {prediction?.emotions || ''}
                                            </p>
                                            <button onClick={() => toggle_Expanded('emotions')} className="font-semibold text-gray-500">
                                                {expanded['emotions'] ? 'Read Less..' : 'Read More..'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <------------ Similar Daily Horoscope Details section's ------------> */}
                            <Similar_Daily_Horoscope_Details />
                        </div>
                    </div>


                </div>
            </section>
            {/* <------ Kundli Common Section --------------->*/}
            <Kundli_Common_Section />

            {/* <----------- Kundli Faq section's ----------->*/}
            <Kundli_Faq />

            {/* <---------------- Private Confidential ----------> */}
            <Home_Private_Confidential />

            {/* <------------ Footer section's ----------------> */}
            <Footer />
        </div>
    )
}

export default Daily_Horoscope_Details